function FarmerDCOUT(){
     return(
           <div>  
             <h2>FarmerDCOUT</h2>
             <p>details here</p>
            </div>
         );
}
export default FarmerDCOUT;